<template>
  <div class="xin">
    <el-tabs>
      <!-- 过滤日志 -->

      <el-tab-pane>
        <span slot="label"> {{ $t("wasteInsulate1.tolname111") }}</span>

        <div class="switch">
          <!-- 查询框 -->
          <div class="main">
            <el-form ref="form" label-width="80px">
              <ul>
                <li>{{ $t("wasteInsulate1.envfrom") }}:</li>
                <el-input
                  placeholder
                  v-model="col.envfrom"
                  clearable
                ></el-input>
                <li>{{ $t("wasteInsulate1.envrcpt") }}:</li>
                <el-input
                  placeholder
                  v-model="col.envrcpt"
                  clearable
                ></el-input>
                <li>{{ $t("wasteInsulate1.subject") }}:</li>
                <el-input
                  placeholder
                  v-model="col.subject"
                  clearable
                ></el-input>
                <li>{{ $t("wasteInsulate1.ip") }}:</li>
                <el-input placeholder v-model="col.ip" clearable></el-input>
                <el-button @click="tanSend">{{ $t("table.search") }}</el-button>
                <el-button
                  @click="xians()"
                  v-show="geng"
                  type="text"
                  class="more_s"
                  >{{ $t("table.more") }}
                </el-button>
                <el-button
                  @click="xians()"
                  v-show="geng1"
                  type="text"
                  class="more_d"
                  >{{ $t("table.more1") }}</el-button
                >
              </ul>
            </el-form>
            <div class="search" v-show="xian">
              <ul>
                <li>{{ $t("wasteInsulate1.mid") }}:</li>

                <el-input placeholder v-model="col.mid" clearable></el-input>
                <li  v-if="this.has_minion_syslog == 1">{{ $t("wasteInsulate1.minion_host") }}:</li>

                <el-select
                  v-model="col.minion_host"
                  v-if="this.has_minion_syslog == 1"
                >
                  <el-option
                    v-for="item in minionhost"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <li v-if="this.SEARCH_APT_STATUS == 1">
                  {{ $t("wasteInsulate1.apt_state") }}:
                </li>

                <el-select
                  v-model="col.apt_status"
                  v-if="this.SEARCH_APT_STATUS == 1"
                >
                  <el-option
                    v-for="item in apt_status_arr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <li>{{ $t("wasteInsulate1.spam_reason") }}:</li>

                <el-select
                  v-model="col.spam_reason"
                  @change="spam_reason_change"
                >
                  <el-option
                    v-for="item in spamreason"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-input
                  placeholder
                  v-model="col.subwhy"
                  clearable
                  v-if="this.subwhy == 1"
                ></el-input>
              </ul>
              <ul>
                <!-- 邮件大小
                            <li>{{ $t("wasteInsulate1.bigs") }}:</li>
                            <div class="mailSize">
                                <el-input v-model="col.min_size"></el-input>
                                <el-select v-model="col.min_size_unit" placeholder="MB">
                                    <el-option v-for="item in size_unit" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                </el-select>{{ $t("wasteInsulate1.zhi") }}
                                <el-input v-model="col.max_size"></el-input>
                                <el-select v-model="col.max_size_unit" placeholder="MB">
                                    <el-option v-for="item in size_unit" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                </el-select>
                            </div>
                            -->
              </ul>
              <ul></ul>
              <ul>
                <li>{{ $t("wasteInsulate1.startdate") }}:</li>
                <el-date-picker
                  v-model="col.startdate"
                  type="datetimerange"
                  :range-separator="$t('wasteInsulate1.zhi')"
                  :start-placeholder="$t('table.sdata')"
                  :end-placeholder="$t('table.enddata')"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="pickerOptions"
                  :default-time="['00:00:00', '23:59:59']"
                ></el-date-picker>
              </ul>
            </div>
          </div>

          <!--  表格 -->

          <div class="table">
            <el-table
              v-loading="loading"
              :data="fileList"
              :cell-class-name="tableCellClassName"
              :row-class-name="tableRowClassName"
              ref="multipleTable"
              tooltip-effect="dark"
              style="width: 100%"
              @selection-change="handleSelectionChange"
            >
              <el-table-column
                type="selection"
                width="40"
                v-model="multipleSelection"
              ></el-table-column> 
              <el-table-column :label="$t('table.tls')" width="40" >
                <template slot-scope="scope">
                  <img v-if="scope.row.SHOWTLS == 1" src="/imgs/tls.png" alt title="tls"/>
                        <img v-if="scope.row.SHOW_WL == 1" src="/imgs/wls.png" alt :title="$t('table.wl')"/>
                </template>
              </el-table-column>
              <el-table-column
                prop="AC_DATE"
                :label="$t('table.maildate')"
                width="100"
              ></el-table-column>
              <el-table-column
                prop="SHOW_MINION"
                :label="$t('table.clusterhost')"
                width="96"
              ></el-table-column>
              <el-table-column
                prop="MID"
                :label="$t('table.ID')"
                width="96"
              ></el-table-column>
              <el-table-column
                prop="IP"
                :label="$t('table.IP')"
                width="102"
              ></el-table-column>
              <el-table-column
                prop="REJ_STAGE"
                :label="$t('wasteInsulate1.stage')"
                width="52"
              ></el-table-column>
              <!--  发件人 -->

              <el-table-column
                prop="ENVFROM"
                :label="$t('table.ENVFROM')"
                width="160"
              >
                <template slot-scope="scope">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="scope.row.ENVFROM"
                    placement="top"
                  >
                    <span> {{ scope.row.SHOW_ENVFROM }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <!--  收件人 -->

              <el-table-column
                prop="ENVRCPT"
                :label="$t('table.ENVRCPT')"
                width="160"
              >
                <template slot-scope="scope">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="scope.row.SHOW_MORE_RCPT"
                    placement="top"
                  >
                    <span> {{ scope.row.ENVRCPT }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                prop="WHY"
                :label="$t('wasteInsulate1.status')"
              ></el-table-column>
              <el-table-column
                prop="SUBJECT"
                :label="$t('table.SUBJECT')"
                :show-overflow-tooltip="true"
              ></el-table-column>
            </el-table>
          </div>

          <!--  分页 -->
          <div class="fenye" v-show="xian6">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalnums"
            ></el-pagination>
            <button @click="derived" class="el-icon-download1" :disabled="$root.jurisdiction.only_query==0">
              {{ $t("table.record") }}
            </button>
          </div>
        </div>
          <div class="pop-up " v-show="derived_show"  v-drag="{ handle: '.pop_up_text_derived_record' }"
            >
              <!--  导出-->
              <div class="pop_up_text pop_up_text_derived_record">
                <span style="padding:0 14px"></span>{{ $t("table.record") }}
              </div>
              <p></p>
          <div class="find">
            <div class="find1">
              <div class="find-text" style="padding-right: 12px;">
                <!-- 条数 -->
                {{ $t("logs.derived") }}:
              </div>
              <div class="block block1">
                <el-input v-model="limit_cn" placeholder=""></el-input>
              </div>
            </div>
            <div class="find1">
              <div class="find-text" style="padding-right: 12px;">
                <!-- 类型 -->
                {{ $t("logs.smtpIp6") }}:
              </div>
              <div class="block block1">
                <el-select v-model="printtype" placeholder="">
                  <el-option
                    v-for="item in printtype_arr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>

          <el-row>
            <el-button type="primary" @click="derived_unit">{{
              $t("logs.report16")
            }}</el-button>
            <el-button type="danger" @click="derived_cancel">{{
              $t("tab.cancel")
            }}</el-button>
          </el-row>
        </div>
        <div class="gray" v-show="derived_show"></div>
      </el-tab-pane>
      <el-tab-pane>
        <!-- 系统原始日志 -->

        <span slot="label"> {{ $t("wasteInsulate1.tolname111_syslog") }}</span>
        <!-- 查询框 -->
        <!-- 查询框 -->
        <div class="main">
          <el-form ref="form" label-width="80px">
            <ul>
              <li class="syslog_query">
                {{ $t("wasteInsulate1.tolname111_syslog1") }}:
              </li>
              <el-input
                placeholder
                v-model="in_param"
                clearable
                style="width:20%"
              ></el-input>
              <el-date-picker
                v-model="sel_date"
                type="date"
                placeholder=""
                class="one_day"
                style="width:12%;margin-right:10px"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions1"
              >
              </el-date-picker>
              <el-select v-model="sel_log" style="width:12%;">
                <el-option
                  v-for="item in sel_log_arr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-select
                v-model="minionhost1"
                style="width:12%;"
                v-if="this.has_minion_syslog == 1"
              >
                <el-option
                  v-for="item in minionhost"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-button @click="search_syslog">{{
                $t("table.search")
              }}</el-button>
            </ul>
          </el-form>
        </div>
        <el-input
          type="textarea"
          :autosize="{ minRows: 20 }"
          placeholder="暂无数据"
          v-model="textarea"
        >
        </el-input>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import FileSaver from "file-saver";
import XLSX from "xlsx";
export default {
  data() {
    return {
      limit_cn_old: "",

      limit_cn: "",
      printtype: "pdf",
      printtype_arr: [],
      derived_show: false,
      minionhost1: "",
      has_minion_syslog: 0,
      sel_log_arr: [],
      sel_log: "maillog",
      textarea: "",
      in_param: "",
      sel_date: "",

      SEARCH_APT_STATUS: "",
      subwhy: "",
      xiazai: false,
      // 只可以选择今天之前的日期
      pickerOptions1: {
        disabledDate(time) {
          // return time.getTime() > Date.now();
          return time.getTime() > Date.now();
        },
      },
      // 只可以选择今天之前的日期
      pickerOptions: {
        disabledDate(time) {
          var todayYear = new Date().getFullYear();
          var todayMonth = new Date().getMonth();
          var todayDay = new Date().getDate();
          var todayTime = new Date(
            todayYear,
            todayMonth,
            todayDay,
            "23",
            "59",
            "59"
          ).getTime(); // 毫秒

          return time.getTime() > todayTime;
        },
      },
      // 查找
      // 查询条件
      col: {
        apt_status: "",
        envfrom: "",
        envrcpt: "",
        ip: "",
        attach: "",
        hdrfrom: "",
        hdrto: "",
        url: "",
        mid: "",
        subject: "",
        body: "",
        minion_host: "",
        startdate: "",
        type: "",
        spam_reason: "",
        haspass: "",
        min_size: "",
        max_size: "",
        min_size_unit: "",
        max_size_unit: "",
        subwhy: "",
      },
      // 总数
      totalnums: 0,
      size: 0,
      // 每页条数
      pagesize: 0,
      //   默认前往第几页
      page: 1,
      xian6: true,
      xian: false,
      btnText: "展示更多",
      multipleSelection: [],
      selectList: [], // 选中的数据
      excelData: [],
      allSelect: false,
      isIndeterminate: true,

      form: {
        username: "",
      },
      // 集群节点
      minionhost: [],

      // 拦截原因
      spamreason: [],
      // 类型
      type1: [],
      // 是否放行
      haspass1: [
        {
          value: "0",
          label: "未放行",
        },
        {
          value: "1",
          label: "已放行",
        },
      ],

      size_unit: [
        {
          value: "MB",
          label: "MB",
        },
        {
          value: "KB",
          label: "KB",
        },
        {
          value: "B",
          label: "B",
        },
      ],
      value: "",
      value1: [new Date(2020, 5, 10, 10, 10), new Date(2020, 6, 11, 10, 10)],
      fileList: [],
      loading: true,
      // 查看
      col1: [],
      // 搜索默认
      col2: {
        apt_status: "",
        envfrom: "",
        envrcpt: "",
        ip: "",
        attach: "",
        hdrfrom: "",
        hdrto: "",
        url: "",
        mid: "",
        subject: "",
        body: "",
        minion_host: "",
        startdate: "",
        type: "",
        spam_reason: "",
        haspass: "",
        min_size: "",
        max_size: "",
        min_size_unit: "",
        max_size_unit: "",
        subwhy: "",
      },
      geng: true,
      geng1: false,
      date_type: "",
      col_search: "",
search_time:0,

    };
  },

  mounted() {
    this.getFileList();
  },

  created() {
    let that = this;
        document.onkeydown = function (e) {
            e = window.event || e;
            // console.log(e.code)

            if ((e.code == 'Enter' || e.code == 'Num Enter' || e.code == 'NumpadEnter')) { //验证在登录界面和按得键是回车键enter
                that.tanSend(); //搜索函数 
            }
        }
  },
  methods: {
    derived_unit() {
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      console.log(sid);

      let col_derived = JSON.parse(JSON.stringify(this.col_search)) 
     

       col_derived.limit_cn=this.limit_cn
       col_derived.printtype=this.printtype
      col_derived.printtofile = 1;
      // let col=col_derived

      let col = JSON.stringify(col_derived);
      // console.log(col,'col')
      // console.log(this.col_search, "col_search");
   // console.log(col_derived, "col_derived");

      if (this.printtype == "csv") {
        let __mode = "download_real_log";
        window.open(
          `/api/adm/cgi/mon.cgi?__mode=${__mode}&sid=${sid}&col=${col}`
        );
      }
      if (this.printtype == "html" || this.printtype == "pdf") {
        let __mode = "real_filterlog";
        window.open(`/api/adm/cgi/newspam.cgi?__mode=${__mode}&sid=${sid}&col=${col}`);
      }
      this.derived_show = false;
    },
    derived_cancel() {
      this.derived_show = false;
    },
    // 导出记录
    derived() {
      this.derived_show = true;
      this.limit_cn = this.limit_cn_old;
    },
    spam_reason_change(val) {
      console.log(val);
      if (val == "combrule" || val == "newrule") {
        this.subwhy = 1;
      } else {
        this.subwhy = 0;
      }
    },
    // 批量放行

    bulkpass() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          message: "请至少勾选一项，再进行操作",
          type: "warning",
        });
        return;
      } else {
        this.loading = true;

        let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
        console.log(sid);
        // console.log(this)
        // 获取表单数据,搜索条件
        let col = this.col;

        var arr = this.multipleSelection;
        // console.log(arr, "全选后，获取的数组");
        let multis = [];
        for (var i = 0; i < arr.length; i++) {
          multis.push(arr[i].SEL_ID);
        }
        console.log(multis, "选中后的批量放行id");
        let multis1 = JSON.stringify(multis);
        this.$axios
          .get("/api/adm/cgi/elkspam.cgi", {
            params: {
              __mode: " elk_archive_delete",
              sid: sid,
              col: col,

              // bulkpassflag: 1,
              msg_json: multis1,
              // screen: "real_filterlog.html",
            },
          })
          .then((res) => {
            console.log(res);
            // this.loading = true;
            if (!res) {
              this.loading = false;
            } else if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
              this.loading = false;
             
            } else if (res.data.fmstatus.code == "3") {
              alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.fileList = res.data.ret.datalist;

              this.totalnums = res.data.ret.col.totalnums;
              this.size = res.data.ret.col.pagesize;
              this.loading = false;
            }
          })
          .catch((err) => {
            console.log("接口错误");
            console.log(err);
            alert(err);
          });
      }
    },

    // 全部下载
    openPostWindow() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          message: "请至少勾选一项，再进行操作",
          type: "warning",
        });
        return;
      } else {
        var arr = this.multipleSelection;
        console.log(arr, "全选后，获取的数组");
        let multis = [];
        for (var i = 0; i < arr.length; i++) {
          multis.push(arr[i].SEL_ID);
        }
        // console.log(multis, "选中后的id");

        let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
        var tempForm = document.createElement("form");
        tempForm.id = "tempForm1";
        tempForm.method = "post";
        tempForm.action = "/api/adm/cgi/elkspam.cgi?";
        tempForm.target = "_blank"; //打开新页面
        var hideInput1 = document.createElement("input");
        hideInput1.type = "hidden";
        hideInput1.name = "__mode"; //后台要接受这个参数来取值
        hideInput1.value = "elk_archive_downzip"; //后台实际取到的值
        var hideInput2 = document.createElement("input");
        hideInput2.type = "hidden";
        hideInput2.name = "sid";
        hideInput2.value = `${sid}`;
        var hideInput3 = document.createElement("input");
        hideInput3.type = "hidden";
        hideInput3.name = "msg_json";
        hideInput3.value = `${multis}`;
        // 这里就是如果需要第二个参数的时候可以自己再设置;
        tempForm.appendChild(hideInput1); //tempForm.appendChild(hideInput2);
        tempForm.appendChild(hideInput2); //tempForm.appendChild(hideInput2);
        tempForm.appendChild(hideInput3); //tempForm.appendChild(hideInput2);
        if (document.all) {
          tempForm.attachEvent("onsubmit", function() {}); //IE
        } else {
          // var subObj = tempForm.addEventListener("submit", function () {}, false); //firefox
        }
        document.body.appendChild(tempForm);
        if (document.all) {
          tempForm.fireEvent("onsubmit");
        } else {
          tempForm.dispatchEvent(new Event("submit"));
        }
        tempForm.submit();
        document.body.removeChild(tempForm);
      }
    },

    downloadExcel() {
      this.$confirm("确定下载列表文件?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.excelData = this.selectData; //你要导出的数据list。
          this.exportExcel();
        })
        .catch(() => {});
    },

    exportExcel() {
      /* 从表生成工作簿对象 */
      var wb = XLSX.utils.table_to_book(document.querySelector("#out-table"));
      /* 获取二进制字符串作为输出 */
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        FileSaver.saveAs(
          //Blob 对象表示一个不可变、原始数据的类文件对象。
          //Blob 表示的不一定是JavaScript原生格式的数据。
          //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
          //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
          new Blob([wbout], {
            type: "application/octet-stream",
          }),
          //设置导出文件名称
          "sheetjs.xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },

    //  getdatatime() {
    //   //默认显示今天
    //   this.value2 = new Date();
    // },
    // 格式化时间，获取当前时间的一个月后的时间值
    Date() {
      var seperator1 = "-";

      var data = new Date();
      var Da = new Date(data.getTime());
      // 以上两行代码为关键代码，若想要返回一天后的时间，则可以将第二行代码更换为下面代码
      // var Da = new Date(data.getTime() + 24 * 60 * 60 * 1000);
      // 若是想要返回值为当前时间，则上面两行代码可以直接修改为下面代码即可。
      // var Da = new Date()
      var year = Da.getFullYear();
      var month = Da.getMonth() + 1;
      var hour = Da.getHours();
      var minutes = Da.getMinutes();
      var seconds = Da.getSeconds();
      var strDate = Da.getDate();

      if (hour >= 1 && hour <= 9) {
        hour = "0" + hour;
      }
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      if (seconds >= 1 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      return (
        year +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        hour +
        ":" +
        minutes +
        ":" +
        seconds
      );
    },
    // 七天前日期
    convertToLateDate() {
      var data = new Date();
      var Da = new Date(data.getTime() - 24 * 60 * 60 * 1000 * 7);
      var seperator1 = "-";
      // 以上两行代码为关键代码，若想要返回一天后的时间，则可以将第二行代码更换为下面代码
      // var Da = new Date(data.getTime() + 24 * 60 * 60 * 1000);
      // 若是想要返回值为当前时间，则上面两行代码可以直接修改为下面代码即可。
      // var Da = new Date()
      // var y = Da.getFullYear();
      // var m = Da.getMonth() + 1;
      // var d = Da.getDate();
      // var H = Da.getHours();
      // var mm = Da.getMinutes();
      // m = m < 10 ? "0" + m : m;
      // d = d < 10 ? "0" + d : d;
      // H = H < 10 ? "0" + H : H;
      // return y + "-" + m + "-" + d + " " + H + ":" + mm;
      var year = Da.getFullYear();
      var month = Da.getMonth() + 1;
      var hour = Da.getHours();
      var minutes = Da.getMinutes();
      var seconds = Da.getSeconds();
      var strDate = Da.getDate();
      if (hour >= 1 && hour <= 9) {
        hour = "0" + hour;
      }
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      if (seconds >= 1 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      return (
        year +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        hour +
        ":" +
        minutes +
        ":" +
        seconds
      );
    },
    //打包下载
    // speedupCheckbox() {
    //   if (this.multipleSelection.length === 0) {
    //     this.$message({
    //       message: "请至少勾选一项，再进行操作",
    //       type: "warning",
    //     });
    //     return;
    //   } else {
    //     // this. openPostWindow()
    //     // this.speedupData();
    //     // this.exportExcel();
    //   }
    // },
    // 表格选中值
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection, "table 框选中的值");
      // console.log(this.table);
    },
    //全选
    speedupData() {
      var arr = this.multipleSelection;
      // console.log(arr, "全选后，获取的数组");
      let multis = [];
      for (var i = 0; i < arr.length; i++) {
        multis.push(arr[i].SEL_ID);
      }
      console.log(multis, "选中后的id");

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      console.log(sid);
      // let msg=JSON.stringify(multis)
      let __mode = "elk_spam_downzip";
      console.log(__mode);

      this.$refs.multipleTable.clearSelection(); //操作完成清除勾选框
    },

    // 更多
    xians: function() {
      this.xian = !this.xian;

      if (this.xian) {
        this.geng = false;
        this.geng1 = true;
      } else {
        this.geng = true;
        this.geng1 = false;
      }
    },
    // 页面加载完成时，

    // 数据

    getFileList() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      console.log(sid);
      // console.log(this)
      // 获取表单数据,搜索条件

      let col = this.col;
      // console.log(col, '5555')

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "real_filterlog",
            sid: sid,
            col: col,

            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          console.log(res);
          // console.log(col, "传的col值");
          this.col1 = this.col;
          // console.log(this.col1, "传的col1值");
          // console.log(this.page, '222')

          // this.loading = true;
          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
            // this.getFileList()
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            if (
              res.data.ret.col.spam_reason == "newrule" ||
              res.data.ret.col.spam_reason == "combrule"
            ) {
              this.subwhy = 1;
            }
            this.fileList = res.data.ret.datalist;
            // 总条数
            this.totalnums = res.data.ret.col.totalnums;
            this.size = res.data.ret.col.pagesize;
            this.page = res.data.ret.col.page;
            this.SEARCH_APT_STATUS = res.data.ret.SEARCH_APT_STATUS;
            // console.log(this.page)
            this.minionhost = res.data.ret.q_minion_host;
            this.sel_log_arr = res.data.ret.q_logtype;

            // this.type1 = res.data.ret.q_spam_reason;
            // 节点
            // this.minionhost = res.data.ret.q_minion_host;
            //  类型
            this.type1 = res.data.ret.q_type;
            this.printtype_arr = res.data.ret.q_printtype;
            // this.limit_cn=res.data.ret.col.limit_cn
            this.limit_cn_old = res.data.ret.col.limit_cn;

            this.sel_date = res.data.ret.CUR_DATE;
            //  原因
            this.spamreason = res.data.ret.q_spam_reason;
            this.apt_status_arr = res.data.ret.q_apt_status;
            if (res.data.ret.HAS_MINION) {
              this.has_minion_syslog = 1;
            }
            this.loading = false;
            // for (let i = 0; i < this.fileList.length; ++i) {
            //     this.fileList[i].SHOW_MORE = '展示更多'
            // }
            // var vm = this;
            // 页面加载完成后渲染日期
          if(this.search_time==0){
            this.col.startdate = res.data.ret.q_date;
              
            }
            this.date_type = res.data.ret.col.startdate;
            this.col_search = res.data.ret.col;
            console.log(this.col_search, "后台返回数据col");
            this.$nextTick(() => {
              this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
            });
            // console.log(this.col.startdate);
          }
        });
    },
    search_syslog() {
      // console.log(col2, "搜索传值");
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      this.$axios
        .get("/api/adm/cgi/mon.cgi", {
          params: {
            __mode: "exec_select_syslog",
            sid: sid,
            in_param: this.in_param,
            sel_date: this.sel_date,
            log: this.sel_log,
            salt_minion_ip_syslog: this.minionhost1,
          },
        })
        .then((res) => {
          console.log(res);

          // this.loading = true;
          // this.loading = true;
          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            console.log(1);
            this.textarea = res.data.ret.RAWOUTPUT;
          }
        });
    },
    // 打开搜素
    tanSend() {
       if(this.geng1==true){
        this.geng = true;
        this.geng1 = false;
        this.xian=false
      }
      this.loading = true;
      // this.page = 1
      const col = {
        apt_status: this.col.apt_status,
        subject: this.col.subject,
        url: this.col.url,
        envfrom: this.col.envfrom,
        envrcpt: this.col.envrcpt,
        mid: this.col.mid,
        ip: this.col.ip,
        attach: this.col.attach,
        hdrfrom: this.col.hdrfrom,
        hdrto: this.col.hdrto,
        body: this.col.body,
        type: this.col.type,
        haspass: this.col.haspass,
        min_size: this.col.min_size,
        max_size: this.col.max_size,
        min_size_unit: this.col.min_size_unit,
        max_size_unit: this.col.max_size_unit,
        spam_reason: this.col.spam_reason,
        startdate: this.col.startdate,
        minion_host: this.col.minion_host,
        page: 1,
        pagesize: this.pagesize,
        subwhy: this.col.subwhy,
      };
      let col2 = col;
      // console.log(col2, "搜索传值");
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "real_filterlog",
            sid: sid,
            col: col2,
          },
        })
        .then((res) => {
          console.log(res);
          // this.loading = false;

          // this.loading = true;
          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            setTimeout(() => {
                 alert(res.data.fmstatus.errmsg);
              }, 100);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            // this.col1 = this.col;
            // let col1 = this.col1;
            // console.log(col1);
            // this.page = 1
            // this.pagesize = 50
               this.search_time=1
            if (
              res.data.ret.col.spam_reason == "newrule" ||
              res.data.ret.col.spam_reason == "combrule"
            ) {
              this.subwhy = 1;
            }
            // this.xian=false
            this.fileList = res.data.ret.datalist;
            this.totalnums = res.data.ret.col.totalnums;
            this.size = res.data.ret.col.pagesize;
            this.page = res.data.ret.col.page;
            this.loading = false;
            this.col_search = res.data.ret.col;
            this.$nextTick(() => {
              this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
            });
            console.log(this.col_search, "后台返回数据col，搜索后");
          }
        });

      // 值清空
      // this.subject = "";
      // this.ip = "";

      // (this.envfrom = ""),
      //   (this.envrcpt = ""),
      //   (this.id = ""),
      //   (this.spam_reason = ""),
      //   (this.startdate = ""),
      //   (this.minion_host = ""),
      //   console.log(this.ip);
    },
    // 各行变色
    tableRowClassName({ rowIndex }) {
      // console.log(row,rowIndex)
      if (rowIndex % 2 == 1) {
        return "warning-row";
        // console.log(2222)
      } else if (rowIndex % 2 !== 1) {
        return "success-row";
      }
      return "";
    },
    tableCellClassName({ row }) {
      // console.log(row);

      if (row.OK === 1) {
        return "sent1";
      }
      return "";
    },

    // 每页显示多少条 -- 切换
    handleSizeChange(val) {
      this.col = this.col_search;
      console.log(this.col, "给后台返回数据1");
      this.col.pagesize = val;

      console.log(this.col, "给后台返回数据2");

      this.getFileList();
      //                   this.$nextTick(() => {
      // 	this.$refs.multipleTable.bodyWrapper.scrollTop = 0
      // })
    },
    // 当前第几页
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.col = this.col_search;
      console.log(this.col, "给后台返回数据1");
      this.col.page = val;
      console.log(this.col, "给后台返回数据2");

      this.getFileList();
    },
    handleCurrentChange2(val) {
      // console.log(`当前页: ${val}`);
      this.page = val;
      //  this.tanSend(this.search,this.pagesize)
      // console.log(this.page, '2', val);
    },
    // 打开详情页
    handleEdit(index, row) {
      // console.log(this.col1);
      console.log(index, row);
      // this.loading = false;

      this.$router.push({
        name: "guiDangListOne1",
        params: {
          rec_id: row.REC_ID,
          index: row.INDEX,
          msgtype: row.MSGTYPE,
          is_elk: 1,
          col1: this.col1,
        },
      });
    },
    // 收件人展示更多

    handleEdit1(index, row) {
      console.log(row);
      this.fileList[index].SHOW_MORE =
        row.SHOW_MORE == `${this.$t("table.show")}`
          ? `${this.$t("table.yin")}`
          : `${this.$t("table.show")}`;
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .sent1 .cell {
  color: #38ca1b !important;
}

// /deep/ .el-table__body tr:hover {
//     cursor: pointer;

// }

.biaodan {
  height: 300px;

  form {
    height: 300px;
  }
}

/deep/ .el-table--border th:first-child .cell {
  padding-left: 0px;
}

/deep/ .el-table__row.el-table .cell:nth-child(1) {
  padding-left: 4px;
}

/deep/ .el-table .cell:nth-child(2) {
  padding-left: 0px;
}

// 滑过每一行变色
/deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #c6cfdf !important;
}

// /deep/ .warning-row {
//   background: #fff;
// }

// /deep/ .success-row {
//   background: #fff;
// }




// .block,
// .jiqun {
//   margin: 10px 0;
// }

.block {
  display: flex;
  align-items: center;
}

.block span {
  margin: 0 38px;
}

/deep/ .el-range-editor.el-input__inner {
  display: flex;
  align-items: center;
}

.jiqun {
  display: flex;
  align-items: center;
  margin: 5px 0;
}

/deep/ .cell {
  text-align: center;
}

/deep/ .el-tabs__nav-scroll {
  display: flex;
  padding-left: 0px;
  justify-content: space-between;
}

// background: #424F63;
/deep/ .el-tabs__item .is-top {
  font-size: 12px;
}

/deep/ .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
  padding-left: 20px;
  border-left: 0px;
}

/deep/ .el-tabs--top .el-tabs__item.is-top:last-child {
  padding-right: 20px;
}

// /deep/ .el-tabs__item.is-active {
//     //   color: #409eff;
//     background: #fff;
// }

/deep/ .el-tabs__active-bar {
  height: 0;
}

// 日期
/deep/.el-date-editor .el-range-separator {
  font-size: 12px;
  line-height: 14px;
}

/deep/ .el-date-editor {
  margin-top: 0;
}

/deep/ .el-date-editor .el-range-input {
  font-size: 12px;
  line-height: 24px;
  width: 50%;
}

/deep/.el-date-editor span {
  margin-bottom: 0px;
}

/deep/ .el-date-editor--datetimerange.el-input__inner {
  width: 330px;
  margin-top: 6px;
}

@import "../../css/liebiao.less";
@import "../../css/pou_up.less";
@import "../../css/drag.less";
.search {
  padding-bottom: 8px;
}
.xin {
  padding: 0;
}
/deep/ .el-tabs__content {
  padding: 0 14px 14px 14px;
}
// 原始日志
.syslog_query {
  width: 210px !important;
}
/deep/ .el-input--prefix .el-input__inner {
  padding-left: 26px;
}
.pop-up .el-input {
  width: 100%;
}
/deep/.el-table__row td:nth-child(2) {
    .cell {
        padding-left: 0px;
        display: flex;
        justify-content: space-around;
    }

    
}
/deep/ .el-tabs__item{
  font-family: PingFangSC-Medium, PingFang SC;
  color: #0E2C5E;
}
/deep/ .el-tabs__item.is-active {
    color: #006BE7;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
}
/deep/ .has-gutter th {
  text-align: left;
  .cell{
  text-align: left;

  }
}

/deep/.el-table__row td{
    .cell {
        text-align: left;
    }

    text-align: left;
}
/deep/ .has-gutter th:nth-child(1),/deep/.el-table__row td:nth-child(1){
      .cell{
  text-align: center;

  }
}
</style>
